import {
	updateWorkOrderStatusTransition,
	completeWorkshopWorkOrder as completeWorkshopWorkOrderApi,
} from "src/services/maintenanceRepair";

type StatusChangeError = {
	code?: number;
	currentState?: string;
};

type StatusChangeAction = "complete" | "cancel";

const STATUS_CHANGE_ERROR_MESSAGES: Record<number, string> = {
	29201: "Work order not found.",
	29202: "This work order's status has already changed. Refresh and try again.",
	29203: "This work order has open jobs that need to be cancelled first.",
	29406: "This work order still has issues attached. Move them to another work order or the backlog first.",
	29051: "That request isn't valid for this transition.",
	29401: "This work order isn't in the workshop yet, or isn't yours to complete.",
	29402: "Give a reason for every issue that wasn't fixed.",
	29405: "Every issue on this work order needs an outcome before you can complete it.",
};

export function statusChangeErrorMessage(
	error: StatusChangeError,
	action: StatusChangeAction = "complete"
): string {
	if (
		action === "complete" &&
		error.code === 29202 &&
		error.currentState !== "PendingCompletion"
	) {
		return "Only work orders in Pending Completion can be marked as completed.";
	}
	return (
		STATUS_CHANGE_ERROR_MESSAGES[error.code] ||
		"Something went wrong. Please try again."
	);
}

export function markWorkOrderCompleted(
	workOrderId: number | string,
	currentState: string,
	setVehicleActive?: boolean,
	fixedIssueIds?: number[]
) {
	return updateWorkOrderStatusTransition(workOrderId, {
		currentState,
		targetState: "Completed",
		forceCancelOpenJobs: true,
		setVehicleActive,
		fixedIssueIds,
	});
}

// Workshop's own completion step (EL-1221) — a different endpoint from
// markWorkOrderCompleted above, which is the ops-side action once the work
// order reaches PendingCompletion.
export function completeWorkshopWorkOrder(
	workOrderId: number | string,
	returnToHomeLot: boolean,
	issues: unknown[]
) {
	return completeWorkshopWorkOrderApi(workOrderId, {
		returnToHomeLot,
		issues,
	});
}

export function completedToastMessage(res: {
	data: { vehicleReactivated?: boolean };
}): string {
	return res.data.vehicleReactivated
		? "Work order completed and vehicle is set to active."
		: "Work order completed.";
}

export function cancelWorkOrder(
	workOrderId: number | string,
	currentState: string,
	reasonCode: string | null,
	notes: string
) {
	return updateWorkOrderStatusTransition(workOrderId, {
		currentState,
		targetState: "Cancelled",
		// Open jobs must be resolved from the jobs table first — the backend
		// rejects with 29203 rather than silently cancelling them.
		forceCancelOpenJobs: false,
		reasonCode,
		notes,
	});
}
